import React from 'react';
import PropTypes from 'prop-types';
import PureComponent from 'ROOT/src/components/pure';
import HomeWidgetHeader from 'ROOT/views/portal/components/Home/HomeWidgetHeader';
import HomeWidgetContent from 'ROOT/views/portal/components/Home/HomeWidgetContent';

/**
 * zobrazuje sloupce na HP, kde jsou dale boxy na budiky
 */
export default class HomeColumns extends PureComponent {
    render() {
        const way = this.props.way;
        const cols = this.props.data.cols.size;

        const render = [];
        // cyklus - pro kazdy sloupec dat na HP
        this.props.data.cols.forEach((col, colIndex) => {
            const lines = [];

            // cyklus - pro kazdy radek s budikem
            col.rows.forEach((row, rowIndex) => {
                if (!row || !row.def || !row.name) {
                    return;
                }
                // drag and drop skryvani
                const style = {};
                style.display = row.def.get('show') ? 'block' : 'none';

                // id grafu pro jeho stazeni
                let chartId = '';
                if (row.def.get('type') == 'chart' && row.data.get('source') == 'chartjs') {
                    chartId = 'chart' + colIndex + 'r' + rowIndex;
                }

                // pridani widgetu do pole
                const line = (
                    <div
                        key={way + '/' + colIndex + '/rows/' + rowIndex}
                        data-way={way + '/' + colIndex + '/rows/' + rowIndex}
                        className={'homeCardPortal ' + (colIndex == 0 ? 'sideLeft' : 'sideRight')}
                        style={style}
                    >

                        {/* <div className='homeCardPortal'
                        key={way + '/' + colIndex + '/rows/' + rowIndex}> */}

                        <HomeWidgetHeader // hlavicka
                            name={row.name}
                            way={way + '/' + colIndex + '/rows'}
                            index={rowIndex}
                            chartId={chartId}
                            type={row.def.get('type')}
                        />

                        <HomeWidgetContent
                            way={way + '/' + colIndex + '/rows/' + rowIndex}
                            data={row.data}
                            def={row.def}
                            chartId={chartId}
                            key={way + '/' + colIndex + '/rows/' + rowIndex + '/' + cols}
                        />
                    </div>

                );

                lines.push(line);
                // else
            }); // konec cyklu s widgety

            // obaleni vsech radku s widgety do jednotlivych sloupcu
            render.push(
                <div className='gridColumnPortalBox' key={way + '/' + colIndex}>
                    <div
                        key={way + '/' + colIndex}
                        className="gridColumnPortal"
                        data-way={way + '/' + colIndex + '/rows'}
                    >
                        {lines}
                    </div>
                </div>,
            );
        });

        // zobrazeni vsech sloupcu a budiku v nich
        return (<div className={'gridContainer flex' + cols}>
            <div className='gridColumnPortalWrapper'>{render}</div>
        </div>);
    }
}

HomeColumns.propTypes = {
    data: PropTypes.shape({
        cols: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    way: PropTypes.string.isRequired, // "home/tabs/" + activeId + "/cols"
};
